module.exports = __webpack_public_path__ + "static/media/Hassan_bin_sabit_logo.f8ae63e0.png";